<template>
    <div class="">
        <div v-if="!file">
            <div :class="['dropZone', dragging ? 'dropZone-over' : '', validation ? '' : 'error--text']"
                 @dragenter="dragging = true"
                 @dragleave="dragging = false"
            >
                <div class="dropZone-info" @drag="onChange">
                    <span class="fa fa-cloud-upload dropZone-title"></span>
                    <span class="dropZone-title">Переместите или загрузите файл</span>
                    <div class="dropZone-upload-limit-info">
                    <br>
                    <div>Максимальный размер файла: 5 МБ</div>
                    </div>
                </div>
                <input type="file" @change="onChange">
            </div>
        </div>
        <div v-else class="dropZone-uploaded">
            <div class="dropZone-uploaded-info">
                <span class="dropZone-title">Файл загружен - {{ file.name }}</span>
                <button type="button" class="next-button button removeFile" style="margin: 0 auto;" @click="removeFile">Удалить файл</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['validation'],
        data:() => ({
            file: '',
            dragging: false
        }),

        methods: {
            onChange(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    this.dragging = false;
                    return;
                }
                this.createFile(files[0]);
            },

            createFile(file) {
                console.log(file);
                if (file.size > 5000000) {
                    PNotify.info('Файл должен быть меньше 5 МБ.')
                    this.dragging = false;
                    return;
                }
                this.file = file;
                this.dragging = false;

                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => {
                    this.$emit('getFile', reader.result)
                };
            },

            removeFile() {
                this.file = '';
                this.$emit('removeFile')
            },
        },
    }
</script>

<style scoped>
    .dropZone {
        width: 80%;
        height: 200px;
        position: relative;
        border: 2px dashed #eee;
    }

    .dropZone:hover {
        border: 2px solid #00ba57;
    }

    .dropZone:hover .dropZone-title {
        color: #00ba57;
    }

    .dropZone-info {
        color: #A8A8A8;
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translate(0, -50%);
        text-align: center;
    }

    .dropZone-title {
        color: #787878;
    }

    .dropZone input {
        position: absolute;
        cursor: pointer;
        top: 0px;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    .dropZone-upload-limit-info {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .dropZone-over {
        background: #5C5C5C;
        opacity: 0.8;
    }

    .error--text{
        border: 2px dashed #ff5252 !important;
    }

    .error--text .dropZone-title{
        color: #ff5252 !important;
    }

    .dropZone-uploaded {
        width: 80%;
        height: 200px;
        position: relative;
        border: 2px dashed #eee;
    }

    .dropZone-uploaded-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #A8A8A8;
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translate(0, -50%);
        text-align: center;
    }

    .removeFile {
        width: 200px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/FileUpload.vue